import React, { useEffect } from "react";
import { Div } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../store/slices/сategoriesSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { RootState } from "../../store";

interface Category {
  id: number; // ID категории
  title: string; // Название категории
  product_category: number; // ID продукта категории
}

interface Review {
  id: number; // ID отзыва
  title: string; // Название отзыва
  product_category: number; // ID категории продукта
}

interface Props {
  review: Review; // Объект отзыва
}

export const ReviewComponent: React.FC<Props> = ({ review }) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const categories = useSelector(
    (state: RootState) => state.categories.categories
  );
  console.log("categories:", categories);

  const categoryId = review.product_category;

  const category = Array.isArray(categories)
    ? categories.find((cat) => cat.id === categoryId)
    : null;

  console.log("category:", category);

  return <Div>{category ? category.title : "Категория не найдена"}</Div>;
};
